import React from "react";
import FoodHome from "./Food/FoodHome";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import RecipeView from "./Food/RecipeView";
import AddRecipe from "./Food/AddRecipe";
import WorkoutHome from "./Workout/WorkoutHome";
import WorkoutView from "./Workout/WorkoutView";
import ShoppingList from "./Food/ShoppingList";
import RandomFoodSelect from "./Food/RandomFoodSelect";
import IngredientReview from "./Food/IngredientReview";
import ContextManager from "./Utility/ContextManager";
import SiteHome from "./Home/SiteHome";
import ChatHome from "./ChatDemo/ChatHome";
import FormulaOneHome from "./Formula1/FormulaOneHome"
import SportsHome from "./Sports/SportsHome";
import AddLift from "./Workout/AddLift";
import HeardleHome from "./Heardle/HeardleHome";
import Heardle from "./Heardle/Heardle";
import MedicineHome from "./Medicine/MedicineHome";
import SportsFantasyFootball from "./Sports/SportsFantasyFootball";
import GuitarTabsHome from "./GuitarTabs/GuitarTabsHome";
import GuitarTabsAdd from "./GuitarTabs/GuitarTabsAdd";
import GuitarTabsView from "./GuitarTabs/GuitarTabsView";
import GuitarTabsGate from "./GuitarTabs/GuitarTabsGate";
import FoodDiaryHome from "./FoodDiary/FoodDiaryHome";
import FoodDiaryAddMeal from "./FoodDiary/FoodDiaryAddMeal";
import FoodDiaryAddSymptom from "./FoodDiary/FoodDiaryAddSymptom";
import FoodDiaryMeals from "./FoodDiary/FoodDiaryMeals";
import FoodDiarySymptoms from "./FoodDiary/FoodDiarySymptoms";
import FoodDiarySummary from "./FoodDiary/FoodDiarySummary";
import FoodDiaryBowelEvents from "./FoodDiary/FoodDiaryBowelEvents";
import FoodDiaryDailyContext from "./FoodDiary/FoodDiaryDailyContext";
import PrivateSectionGate from "./Utility/PrivateSectionGate";
import BabyTrackerHome from "./BabyTracker/BabyTrackerHome";
import BabyTrackerEvents from "./BabyTracker/BabyTrackerEvents";
import BabyTrackerCategoryPage from "./BabyTracker/BabyTrackerCategoryPage";
import BabyTrackerFeedingChart from "./BabyTracker/BabyTrackerFeedingChart";
import ScrapbookHome from "./Scrapbook/ScrapbookHome";
import ScrapbookAdmin from "./Scrapbook/ScrapbookAdmin";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route element={<ContextManager type="Home"/>}>
            <Route exact path="/" element={<SiteHome />}></Route>
          </Route>
          
          <Route element={<ContextManager  type="Food"/>}>
            <Route exact path="/food" element={<FoodHome  />}></Route>
            <Route
              path="/food/view"
              element={<RecipeView ></RecipeView>}
            ></Route>
            <Route path="/food/add" element={<AddRecipe></AddRecipe>}></Route>
            <Route
              path="/food/ShoppingList"
              element={<ShoppingList></ShoppingList>}
            ></Route>
            <Route
              path="/food/RandomFood"
              element={<RandomFoodSelect ></RandomFoodSelect>}
            ></Route>
            <Route
              path="/food/ingredient-review"
              element={<IngredientReview />}
            ></Route>
          </Route>
          <Route element={<ContextManager type="FoodDiary"/>}>
            <Route exact path="/food-diary" element={<PrivateSectionGate title="Food diary" description="Sign in to view and manage your private food, symptom, and context tracking data."><FoodDiaryHome /></PrivateSectionGate>}></Route>
            <Route exact path="/food-diary/add-meal" element={<PrivateSectionGate title="Food diary" description="Sign in to add meals to your private diary."><FoodDiaryAddMeal /></PrivateSectionGate>}></Route>
            <Route exact path="/food-diary/add-symptom" element={<PrivateSectionGate title="Food diary" description="Sign in to add symptoms to your private diary."><FoodDiaryAddSymptom /></PrivateSectionGate>}></Route>
            <Route exact path="/food-diary/meals" element={<PrivateSectionGate title="Food diary" description="Sign in to view your meal history."><FoodDiaryMeals /></PrivateSectionGate>}></Route>
            <Route exact path="/food-diary/symptoms" element={<PrivateSectionGate title="Food diary" description="Sign in to view your symptom history."><FoodDiarySymptoms /></PrivateSectionGate>}></Route>
            <Route exact path="/food-diary/summary" element={<PrivateSectionGate title="Food diary" description="Sign in to review your private diary summary."><FoodDiarySummary /></PrivateSectionGate>}></Route>
            <Route exact path="/food-diary/bowel-events" element={<PrivateSectionGate title="Food diary" description="Sign in to review your bowel event log."><FoodDiaryBowelEvents /></PrivateSectionGate>}></Route>
            <Route exact path="/food-diary/daily-context" element={<PrivateSectionGate title="Food diary" description="Sign in to review your daily context entries."><FoodDiaryDailyContext /></PrivateSectionGate>}></Route>
          </Route>
          <Route element={<ContextManager type="BabyTracker"/>}>
            <Route exact path="/baby-tracker" element={<PrivateSectionGate className="BabyTrackerLogin" title="Baby tracker" description="Sign in to view and manage shared baby tracking data."><BabyTrackerHome /></PrivateSectionGate>}></Route>
            <Route exact path="/baby-tracker/diapers" element={<PrivateSectionGate className="BabyTrackerLogin" title="Baby tracker" description="Sign in to view and manage diaper changes."><BabyTrackerCategoryPage category="diaper" /></PrivateSectionGate>}></Route>
            <Route exact path="/baby-tracker/feeding" element={<PrivateSectionGate className="BabyTrackerLogin" title="Baby tracker" description="Sign in to view and manage feeding events."><BabyTrackerCategoryPage category="feeding" /></PrivateSectionGate>}></Route>
            <Route exact path="/baby-tracker/feeding-chart" element={<PrivateSectionGate className="BabyTrackerLogin" title="Baby tracker" description="Sign in to view the feeding timeline."><BabyTrackerFeedingChart /></PrivateSectionGate>}></Route>
            <Route exact path="/baby-tracker/sleep" element={<PrivateSectionGate className="BabyTrackerLogin" title="Baby tracker" description="Sign in to view and manage sleep events."><BabyTrackerCategoryPage category="sleep" /></PrivateSectionGate>}></Route>
            <Route exact path="/baby-tracker/events" element={<PrivateSectionGate className="BabyTrackerLogin" title="Baby tracker" description="Sign in to add and review baby tracking events."><BabyTrackerEvents /></PrivateSectionGate>}></Route>
          </Route>
          <Route element={<ContextManager type="Scrapbook"/>}>
            <Route exact path="/scrapbook" element={<PrivateSectionGate className="BabyTrackerLogin" title="Jon Scrapbook" description="Sign in to view Jon's private scrapbook."><ScrapbookHome /></PrivateSectionGate>}></Route>
            <Route exact path="/scrapbook/admin" element={<PrivateSectionGate className="BabyTrackerLogin" title="Jon Scrapbook" description="Sign in to manage Jon's private scrapbook."><ScrapbookAdmin /></PrivateSectionGate>}></Route>
          </Route>
          <Route element={<ContextManager type="Workout"/>}>
            <Route exact path="/workout" element={<WorkoutHome />}></Route>
            <Route exact path="/workout/AddLift" element={<AddLift />}></Route>
            <Route path="/workout/:id" element={<WorkoutView />}></Route>
          </Route>
          <Route element={<ContextManager type="Sports"/>}>
            <Route exact path="/sports" element={<SportsHome />}></Route>
            <Route exact path="/sports/formula1" element={<FormulaOneHome />}></Route>
            <Route exact path="/sports/fantasyfootball" element={<SportsFantasyFootball />}></Route>
          </Route>
          <Route element={<ContextManager type="Chat"/>}>
            <Route exact path="/chat" element={<ChatHome />}></Route>
          </Route>
          <Route element={<ContextManager type="Heardle"/>}>
            <Route exact path="/heardle" element={<HeardleHome />}></Route>
            <Route
              path="/heardle/play"
              element={<Heardle ></Heardle>}
            ></Route>
          </Route>
          <Route element={<ContextManager type="Medicine"/>}>
          <Route exact path="/medicine" element={<MedicineHome />}></Route>
          </Route>
          <Route element={<ContextManager type="GuitarTabs"/>}>
            <Route exact path="/guitar-tabs" element={<GuitarTabsGate><GuitarTabsHome /></GuitarTabsGate>}></Route>
            <Route exact path="/guitar-tabs/add" element={<GuitarTabsGate><GuitarTabsAdd /></GuitarTabsGate>}></Route>
            <Route exact path="/guitar-tabs/view" element={<GuitarTabsGate><GuitarTabsView /></GuitarTabsGate>}></Route>
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
